import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { configOnEditing } from "../redux/actions/configActions";
import { tabSelect } from "../redux/actions/tabActions";
import { RoutePaths } from "../utils/Items";
import { useTranslation } from "./useTranslation";

const useConfig = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t, BundleKey } = useTranslation();

  type DialogProps = {
    goBack?: boolean,
    route?: string,
    action?: () => void,
  };

  const openDialogAreYouSure = (options?: DialogProps) => {
    dispatch(
      configOnEditing({
        show: true,
        title: t(BundleKey.DIALOG_LEAVEENTRY_MESSAGE),
        labelYes: t(BundleKey.DIALOG_LEAVEENTRY_ACTION),
        action: options?.action
          ? options.action
          : () => {
              if (options?.goBack) history.goBack();
              else if (options?.route) history.push(options.route);
              else history.push(RoutePaths.Dashboard);
            },
      })
    );
  };

  const openDialogOnHold = (options?: DialogProps) => {
    dispatch(
      configOnEditing({
        show: true,
        title: t(BundleKey.TAB_ONHOLD_MESSAGE),
        labelYes: t(BundleKey.TAB_ONHOLD_ACTION),
        action: () => {
          if (options?.goBack) history.goBack();
          else if (options?.route) {
            if (options.route !== RoutePaths.EntryEvent)
              dispatch(tabSelect("-1"));
            history.push(options.route);
          } else history.push(RoutePaths.Dashboard);
        },
      })
    );
  };
  return { openDialogAreYouSure, openDialogOnHold };
};

export default useConfig;
